import type { OrgRole } from '@barso/shared';
import type { OrgKind } from '../api/endpoints';
import type { IconName } from '../components/icons';

/**
 * Bezeichnungen und Symbole der Organisationsarten und Rollen (aus `orgs.tsx`, damit die Startseite sie ohne das
 * ganze Modul „orgs“ laden kann).
 */
export const KIND_LABELS: Record<OrgKind, string> = {
  club: 'Verein',
  daycare: 'Kita',
  school: 'Schule',
  private: 'Privat',
  other: 'Sonstiges',
};

export const ROLE_LABELS: Record<OrgRole, string> = {
  owner: 'Inhaber',
  admin: 'Verwalter',
  member: 'Mitglied',
};

export const KIND_ICONS: Record<OrgKind, IconName> = {
  club: 'users',
  daycare: 'home',
  school: 'school',
  private: 'user',
  other: 'blocks',
};
